<template>
  <TsNuxtCard
    :data-testid="props.dataTestid + '-available-payment-methods-card'"
    noShadow
    append-class="bg-white px-3 py-5 rounded-md border-[#7BBAF5]"
  >
    <div class="flex">
      <TsIcon
        name="material-symbols:lock-outline"
        size="20"
        class="mr-1.5 text-primary"
      />
      <div class="mb-4">
        <TsTypography
          weight="semibold"
          append-class="mb-1 leading-[12px] text-idle-black"
          :data-testid="props.dataTestid + '-payment-secure-transaction-text'"
          >{{ useTranslation("Chekout-secureTransaction", "100% Secure transaction") }}
          <br />
        </TsTypography>
        <p
          :data-testid="
            props.dataTestid + '-payment-secure-ssl-encryption-text'
          "
        >
          {{ useTranslation("Checkout-secureEncryptionTitle", "Secure SSL Encryption") }}
        </p>
      </div>
    </div>
    <div class="flex flex-wrap ml-6 *:mr-8 gap-y-4">
      <TsImage
        src="/icons/ic_outline-apple.svg"
        :data-testid="props.dataTestid + '-apple-pay-logo'"
        :alt="props.dataTestid + '-apple-pay-logo'"
        width="28"
        loading="lazy"
      />
      <TsImage
        src="/icons/paypal.svg"
        :data-testid="props.dataTestid + '-paypal-logo'"
        :alt="props.dataTestid + '-paypal-logo'"
        height="47"
        width="28"
        loading="lazy"
      />
      <TsImage
        src="/icons/american-express.svg"
        :alt="props.dataTestid + '-american-express-visa-logo'"
        :data-testid="props.dataTestid + '-american-express-visa-logo'"
        height="47"
        width="40"
        loading="lazy"
      />
      <TsImage
        src="/icons/i-deal.svg"
        :alt="props.dataTestid + '-ideal-logo'"
        :data-testid="props.dataTestid + '-ideal-logo'"
        height="47"
        width="28"
        loading="lazy"
      />
      <TsImage
        src="/icons/master-card.svg"
        :alt="props.dataTestid + '-master-card-logo'"
        :data-testid="props.dataTestid + '-master-card-logo'"
        height="47"
        width="28"
        loading="lazy"
      />
      <TsImage
        src="/icons/google-pay.svg"
        :alt="props.dataTestid + '-google-pay-logo'"
        :data-testid="props.dataTestid + '-google-pay-logo'"
        height="47"
        width="28"
        loading="lazy"
      />
      <TsImage
        src="/icons/image-1.png"
        :alt="props.dataTestid + '-pro-card-logo'"
        :data-testid="props.dataTestid + '-pro-card-logo'"
        height="28"
        width="40"
        loading="lazy"
      />
      <TsImage
        src="/icons/visa.svg"
        :data-testid="props.dataTestid + '-visa-card-logo'"
        :alt="props.dataTestid + '-visa-card-logo'"
        height="47"
        width="28"
        loading="lazy"
      />
    </div>
  </TsNuxtCard>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";

const TsNuxtCard = defineAsyncComponent(
    () => import('~/components/organisms/TsNuxtCard.vue')
);

type Props = {
  dataTestid: string;
};
const props = withDefaults(defineProps<Props>(), {});
</script>
